<template>
  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay" ref="pdfContent" id="contentToPrint">
        <section class="dashboard-hero">
          <div class="dashboard-hero-main">
            <div class="dashboard-brand">
              <span class="dashboard-brand-icon">
                <i class="fa-solid fa-chart-line"></i>
              </span>
              <span>CrediCore</span>
            </div>
            <p class="dashboard-eyebrow">Resumen ejecutivo</p>
            <h1 class="dashboard-title">Dashboard de cartera</h1>
            <p class="dashboard-subtitle">
              Control de mora, recuperacion e indicadores clave por sucursal, asesor y tipo de cartera.
            </p>
          </div>
          <div class="dashboard-actions">
            <div class="dashboard-context-chip">
              <i class="fa-regular fa-calendar"></i>
              <span>{{ fechaDashboardVisible }}</span>
            </div>
            <div class="dashboard-context-chip">
              <i class="fa-solid fa-building-columns"></i>
              <span>{{ etiquetaSucursal(this.sucursal) || 'Sin filtro' }}</span>
            </div>
            <button @click="generatePDF" class="btn dashboard-download-btn">
              <i class="fa-solid fa-download"></i>
              <span>Descargar PDF</span>
            </button>
          </div>
        </section>

        <section class="dashboard-filters">
          <div class="filter-item">
            <label>Sucursal</label>
            <select v-model="sucursal" class="form-select mb-3 dashboard-select" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option v-for="(sucursal, index) in this.sucursales" :key="index" :value="sucursal">{{ etiquetaSucursal(sucursal) }}
              </option>

            </select>
          </div>
          <div v-if="(this.asesores || []).length > 0 && (this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)"
            class="filter-item">
            <label>Asesor</label>
            <select v-model="this.asesor" class="form-select mb-3 dashboard-select" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option value="Mostrar Todos">Mostrar Todos
              </option>
              <option v-for="(asesor, index) in this.asesores" :key="index" :value="asesor.id">{{ asesor.first_name }}
                {{ asesor.last_name }}
              </option>

            </select>
          </div>

          <div v-if="(this.asesores || []).length > 0 && (this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)"
            class="filter-item">
            <label>Tipo Cartera</label>
            <select v-model="this.tipoCartera" class="form-select mb-3 dashboard-select" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option :value="0">Mostrar Todos
              </option>
              <option v-for="(tipo, index) in this.tiposCartera" :key="index" :value="tipo.id">{{ tipo.nombre }}
              </option>

            </select>
          </div>
          <div v-if="(this.asesores || []).length > 0 && (this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)"
            class="filter-item">
            <label>Otro Estado</label>
            <select v-model="this.estadoSeleccionado" class="form-select mb-3 dashboard-select" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option value="0">Mostrar Todos
              </option>
              <option value="Fallecido">Fallecido</option>
              <option value="Legal">Legal</option>
              <option value="Devuelto">Devuelto</option>

            </select>
          </div>
        </section>

        <section class="dashboard-history-panel">
          <div class="history-copy">
            <label>Histórico</label>
            <strong>{{ historicoActivo ? 'Snapshot guardado' : 'Datos actuales' }}</strong>
            <span v-if="snapshotSeleccionado">Realizado: {{ formatearFechaHora(snapshotSeleccionado.fechaCorte) }}</span>
            <span v-else>Sin snapshot seleccionado</span>
          </div>
          <div class="history-controls">
            <VueDatePicker
              v-model="fechaSnapshotSeleccionada"
              class="dashboard-history-datepicker"
              locale="es"
              :enable-time-picker="false"
              :disabled-dates="deshabilitarFechaSnapshot"
              :clearable="true"
              auto-apply
              placeholder="Seleccionar snapshot"
              @update:model-value="seleccionarFechaSnapshot"
            />
            <button class="btn btn-outline-dark dashboard-history-btn" type="button" @click="volverDashboardActual" :disabled="!historicoActivo">
              <i class="fa-solid fa-rotate-left"></i>
              <span>Actual</span>
            </button>
          </div>
        </section>

        <!-- Content -->

        <div v-if="ready && !sinInformacion">
          <section class="dashboard-kpi-grid">
            <article class="metric-card metric-card-dark">
              <div class="metric-icon">
                <i class="fa-solid fa-wallet"></i>
              </div>
              <div>
                <p>Cartera activa</p>
                <h3>{{ carteraActivaTotal }} <span>creditos</span></h3>
                <small>Saldo capital: {{ formatoNumero(saldoCarteraActiva) }} {{ moneda }}</small>
              </div>
            </article>
            <article class="metric-card">
              <div class="metric-icon metric-icon-warning">
                <i class="fa-solid fa-triangle-exclamation"></i>
              </div>
              <div>
                <p>Mora total</p>
                <h3>{{ moraTotalDashboard }} <span>%</span></h3>
                <small>{{ noClientesRangos }} clientes evaluados</small>
              </div>
            </article>
            <article class="metric-card">
              <div class="metric-icon metric-icon-success">
                <i class="fa-solid fa-hand-holding-dollar"></i>
              </div>
              <div>
                <p>Recuperado mes</p>
                <h3>{{ formatoNumero(this.dashboard?.montoPagosHoyMesHoy || 0) }}</h3>
                <small>{{ moneda }} en pagos del mes actual</small>
              </div>
            </article>
            <article class="metric-card">
              <div class="metric-icon metric-icon-info">
                <i class="fa-solid fa-gauge-high"></i>
              </div>
              <div>
                <p>Calidad cartera</p>
                <h3>{{ Math.floor(this.calidadCartera || 0) }} <span>%</span></h3>
                <small>Indicador calculado sobre saldos de mora</small>
              </div>
            </article>
            <article class="metric-card">
              <div class="metric-icon metric-icon-muted">
                <i class="fa-solid fa-circle-check"></i>
              </div>
              <div>
                <p>Cancelados</p>
                <h3>{{ this.dashboard?.noCancelados || 0 }} <span>creditos</span></h3>
                <small>Saldo capital: {{ formatoNumero(this.dashboard?.saldoCancelados || 0) }} {{ moneda }}</small>
              </div>
            </article>
          </section>

          <div class="row">
            <!-- <div class="col-md-12 grid-margin stretch-card"> -->
            <!-- <div :class="(this.sucursal=='ALL')?'col-md-12 grid-margin stretch-card':'col-md-3 grid-margin stretch-card'">
            <div class="card">
              <div class="card-body">
                <h4 class="grey text-md-center text-xl-left">Total Créditos:</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noCreditos }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                    this.formatoNumero(this.dashboard?.saldoActivos + this.dashboard?.saldoVencidos+ this.dashboard?.saldoLegal) }} {{ this.moneda
                    }} </p>

                  <p class="mt-1 mb-0 text-success">100% </p>

                </div>
              </div>
            </div>
          </div> -->
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card dashboard-kpi-card">
                <div class="card-body">
                  <h4 class="text-success text-md-center text-xl-left">Cartera Activa:</h4>
                  <div
                    class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noActivos +
                      this.dashboard.noVencidos + this.dashboard.noLegal }} créditos
                    </h4>
                    <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                      this.formatoNumero(this.dashboard?.saldoActivos + this.dashboard?.saldoVencidos +
                        this.dashboard?.saldoLegal) }} {{ this.moneda
                      }} </p>

                    <!-- <p class="mb-0 mt-2 text-success">{{
                    ((this.dashboard.noActivos * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-success text-md-center text-xl-left">Créditos Activos:</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noActivos }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                    this.formatoNumero(this.dashboard?.saldoActivos) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-success">{{
                    ((this.dashboard.noActivos * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div> -->
            <!-- <div class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-warning text-md-center text-xl-left">Créditos Vencidos:</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noVencidos }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{ this.formatoNumero(
                    this.dashboard?.saldoVencidos) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-warning">{{
                    ((this.dashboard.noVencidos * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-primary text-md-center text-xl-left">Créditos Cancelados</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noCancelados }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{ this.formatoNumero(
                    this.dashboard?.saldoCancelados) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-primary">{{
                    ((this.dashboard.noCancelados * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div> -->
            <!-- <div v-if="this.sucursal=='ALL'" class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-primary text-md-center text-xl-left">Créditos Legales</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noLegal }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{ this.formatoNumero(
                    this.dashboard?.saldoLegal) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-primary">{{
                    ((this.dashboard.noLegal * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div> -->


          </div>



          <!-- ****************************************************************************************** -->
          <!-- Rangos de Mora -->

          <!-- {{this.formatoNumero(this.dashboard?.totalAprobado)}} -->

          <div class="row card-2 dashboard-mora-row">
            <div class="col-lg-8 col-12 mora-column-panel">
              <div class="mora-table-toolbar">
                <h4 class="text-danger mb-2 text-center">Rangos de Mora</h4>
                <button class="btn btn-outline-dark mora-toggle-btn" type="button" @click="mostrarColumnasDetalleMora = !mostrarColumnasDetalleMora">
                  <i :class="mostrarColumnasDetalleMora ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                  <span>{{ mostrarColumnasDetalleMora ? 'Ocultar detalle' : 'Mostrar detalle' }}</span>
                </button>
              </div>

              <div class="mora-scroll-wrapper">
              <table class="table mora-rangos-table" :class="{ 'mora-detalle-visible': mostrarColumnasDetalleMora }" id="my-data-table">
                <thead>
                  <tr>
                    <th scope="col">Rangos</th>
                    <th scope="col" class="mora-left-header mora-clientes-header">No.Clientes</th>
                    <th scope="col" class="mora-detail-column mora-left-header">Saldo de Capital</th>
                    <!-- <th scope="col">Capital Atrasado</th> -->
                    <th scope="col" class="mora-detail-column mora-left-header">Saldo Interes corriente (A la fecha)</th>
                    <th scope="col" class="mora-detail-column mora-left-header">Saldo Intereres Moratorio(A la fecha)</th>
                    <th scope="col" class="table-secondary mora-total-header mora-vencido-header">Total Saldo Vencido a pagar (A la fecha)</th>
                    <th scope="col" class="table-secondary mora-total-header">Total Saldo a pagar para cancelación (A la fecha)</th>
                    <th scope="col" class="mora-percent-header">Porcentajes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr @click="abrirDetalle('AL_DIA')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">Al día</th>
                    <td>{{ this.dashboard.noVigente }}</td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoVigente) }} {{ this.moneda }} </td>
                    <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasadoVigente) }} {{ this.moneda }} </td> -->
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteresVigente) }} {{ this.moneda }} </td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMoraVigente) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasadoVigente + this.dashboard?.saldoInteresVigente +
                      this.dashboard?.saldoMoraVigente
                    ) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoVigente + this.dashboard?.saldoInteresVigente +
                      this.dashboard?.saldoMoraVigente
                    ) }} {{ this.moneda }} </td>
                    <td>{{ porcentajeSeguro(this.dashboard?.saldoVigente, this.totalSaldoRangos) }} %</td>
                  </tr>
                  <tr @click="abrirDetalle('MORA_1_30')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">1 - 30 días</th>
                    <td>{{ this.dashboard.no30Dias }}</td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldo30Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado30Dias) }} {{ this.moneda }} </td> -->
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteres30Dias) }} {{ this.moneda }} </td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMora30Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado30Dias + this.dashboard.saldoInteres30Dias + this.dashboard?.saldoMora30Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo30Dias + this.dashboard.saldoInteres30Dias + this.dashboard?.saldoMora30Dias)
                    }} {{ this.moneda }} </td>
                    <td>{{ porcentajeSeguro(this.dashboard?.saldo30Dias, this.totalSaldoRangos) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('MORA_31_60')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">31 - 60 días</th>
                    <td>{{ this.dashboard.no60Dias }}</td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldo60Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado60Dias) }} {{ this.moneda }} </td> -->
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteres60Dias) }} {{ this.moneda }} </td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMora60Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado60Dias + this.dashboard?.saldoInteres60Dias +
                      this.dashboard?.saldoMora60Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo60Dias + this.dashboard?.saldoInteres60Dias +
                      this.dashboard?.saldoMora60Dias)
                    }} {{ this.moneda }} </td>
                    <td>{{ porcentajeSeguro(this.dashboard?.saldo60Dias, this.totalSaldoRangos) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('MORA_61_90')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">61 - 90 días</th>
                    <td>{{ this.dashboard.no89Dias }}</td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldo89Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado89Dias) }} {{ this.moneda }} </td> -->
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteres89Dias) }} {{ this.moneda }} </td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMora89Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado89Dias + this.dashboard?.saldoInteres89Dias +
                      this.dashboard?.saldoMora89Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo89Dias + this.dashboard?.saldoInteres89Dias +
                      this.dashboard?.saldoMora89Dias)
                    }} {{ this.moneda }} </td>

                    <td>{{ porcentajeSeguro(this.dashboard?.saldo89Dias, this.totalSaldoRangos) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('MORA_91_180')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">91 - 180 días</th>
                    <td>{{ this.dashboard.noMoraContable }}</td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMoraContable) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasadoMoraContable) }} {{ this.moneda }} </td> -->
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteresMoraContable) }} {{ this.moneda }} </td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMoraMoraContable) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasadoMoraContable + this.dashboard?.saldoInteresMoraContable +
                      this.dashboard?.saldoMoraMoraContable)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMoraContable + this.dashboard?.saldoInteresMoraContable +
                      this.dashboard?.saldoMoraMoraContable)
                    }} {{ this.moneda }} </td>
                    <td>{{ porcentajeSeguro(this.dashboard?.saldoMoraContable, this.totalSaldoRangos) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('MORA_181_MAS')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">181 días en adelante</th>
                    <td>{{ this.dashboard.no181Dias }}</td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldo181Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado181Dias) }} {{ this.moneda }} </td> -->
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteres181Dias) }} {{ this.moneda }} </td>
                    <td class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMora181Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado181Dias + this.dashboard?.saldoInteres181Dias +
                      this.dashboard?.saldoMora181Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo181Dias + this.dashboard?.saldoInteres181Dias +
                      this.dashboard?.saldoMora181Dias)
                    }} {{ this.moneda }} </td>

                    <td>{{ porcentajeSeguro(this.dashboard?.saldo181Dias, this.totalSaldoRangos) }} %</td>

                  </tr>
                  <tr class="table-danger">
                    <th scope="row">Total</th>

                    <th>{{ this.noClientesRangos }} </th>
                    <th class="mora-detail-column">{{ this.formatoNumero(
                      this.totalSaldoRangos) }} {{ this.moneda }} </th>
                    <!-- <th>{{ this.formatoNumero(
                      this.totalSaldoAtrasadoRangos) }} {{ this.moneda }} </th> -->
                    <th class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoInteresVigente + this.dashboard?.saldoInteres30Dias +
                      this.dashboard?.saldoInteres60Dias + this.dashboard?.saldoInteres89Dias +
                      this.dashboard?.saldoInteresMoraContable + this.dashboard?.saldoInteres150Dias + this.dashboard?.saldoInteres180Dias + this.dashboard?.saldoInteres181Dias) }} {{ this.moneda }} </th>
                    <th class="mora-detail-column">{{ this.formatoNumero(
                      this.dashboard?.saldoMoraVigente + this.dashboard?.saldoMora30Dias +
                      this.dashboard?.saldoMora60Dias
                      + this.dashboard?.saldoMora89Dias + this.dashboard?.saldoMoraMoraContable + this.dashboard?.saldoMora150Dias + this.dashboard?.saldoMora180Dias + this.dashboard?.saldoMora181Dias) }} {{ this.moneda }}
                    </th>
                    <th class="">{{ this.formatoNumero(
                      (this.dashboard?.saldoAtrasadoVigente + this.dashboard?.saldoInteresVigente +
                        this.dashboard?.saldoMoraVigente) +
                      (this.dashboard?.saldoAtrasado30Dias + this.dashboard.saldoInteres30Dias +
                        this.dashboard?.saldoMora30Dias) +
                      (this.dashboard?.saldoAtrasado60Dias + this.dashboard?.saldoInteres60Dias +
                        this.dashboard?.saldoMora60Dias) +
                      (this.dashboard?.saldoAtrasado89Dias + this.dashboard?.saldoInteres89Dias +
                        this.dashboard?.saldoMora89Dias) +
                      (this.dashboard?.saldoAtrasadoMoraContable +
                        this.dashboard?.saldoInteresMoraContable + this.dashboard?.saldoMoraMoraContable)+
                        (this.dashboard?.saldoAtrasado150Dias + this.dashboard?.saldoInteres150Dias + this.dashboard?.saldoMora150Dias) +
                        (this.dashboard?.saldoAtrasado180Dias + this.dashboard?.saldoInteres180Dias + this.dashboard?.saldoMora180Dias) +
                        (this.dashboard?.saldoAtrasado181Dias + this.dashboard?.saldoInteres181Dias + this.dashboard?.saldoMora181Dias)

                    ) }} {{ this.moneda }} </th>
                    <th class="">{{ this.formatoNumero(
                      (this.dashboard?.saldoVigente + this.dashboard?.saldoInteresVigente +
                        this.dashboard?.saldoMoraVigente) +
                      (this.dashboard?.saldo30Dias + this.dashboard.saldoInteres30Dias +
                        this.dashboard?.saldoMora30Dias) +
                      (this.dashboard?.saldo60Dias + this.dashboard?.saldoInteres60Dias +
                        this.dashboard?.saldoMora60Dias) +
                      (this.dashboard?.saldo89Dias + this.dashboard?.saldoInteres89Dias +
                        this.dashboard?.saldoMora89Dias) +
                      (this.dashboard?.saldoMoraContable +
                        this.dashboard?.saldoInteresMoraContable + this.dashboard?.saldoMoraMoraContable)+
                        (this.dashboard?.saldo150Dias + this.dashboard?.saldoInteres150Dias + this.dashboard?.saldoMora150Dias) +
                        (this.dashboard?.saldo180Dias + this.dashboard?.saldoInteres180Dias + this.dashboard?.saldoMora180Dias) +
                        (this.dashboard?.saldo181Dias + this.dashboard?.saldoInteres181Dias + this.dashboard?.saldoMora181Dias)
                    ) }} {{ this.moneda }} </th>
                    <th>100%</th>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>



            <div class="col-lg-4 col-12 mora-column-panel mt-lg-0 mt-4 d-flex flex-column justify-content-center">
              <div class="mora-table-toolbar mora-percent-toolbar">
                <div>
                  <p class="mora-percent-context">{{ etiquetaSucursal(this.sucursal) || 'Sin filtro' }}</p>
                  <h4 class="text-warning">Mora en Porcentajes</h4>
                </div>
                <button class="btn btn-outline-dark mora-toggle-btn" type="button" @click="detallesMora()">
                  <i :class="estadoMora === 1 ? 'fa-solid fa-circle-info' : 'fa-solid fa-eye-slash'"></i>
                  <span>{{ estadoMora === 1 ? 'Mostrar detalle' : 'Ocultar detalle' }}</span>
                </button>
              </div>

              <div class="mora-scroll-wrapper mora-percent-scroll">
              <table class="table">
                <thead>
                  <tr>
                    <!-- <th scope="col">Mora 1-30</th> -->
                    <th scope="col">Mora Financiera</th>
                    <th scope="col">Mora Contable</th>
                    <th scope="col">Mora Total</th>
                  </tr>
                </thead>
                <tbody v-if="this.estadoMora === 1">
                  <tr>
                    <!-- <td>{{ ((this.dashboard?.saldo30Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td> -->

                    <!-- <th>{{ (
                      ((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable) /
                        this.totalSaldoRangos) * 100).toFixed(2) }} %</th> -->
                        <th>{{ moraFinancieraDashboard }} %</th>
                        <th>{{ moraContableDashboard }} %</th>

                    <!-- <th>{{ (
                      ((this.dashboard?.saldoMoraContable) / this.totalSaldoRangos) * 100).toFixed(2) }} %</th> -->


                    <th>{{ moraTotalDashboard }} %</th>
                  </tr>

                </tbody>
                <tbody v-if="this.estadoMora === 2">
                  <tr>
                    <!-- <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero(this.dashboard.saldo30Dias)}  ${this.moneda} }{${this.formatoNumero(this.totalSaldoRangos)}   ${this.moneda}})*100 ` " /> 
                    </th> -->
                    <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero( this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable)}  ${this.moneda} }{${this.formatoNumero(this.dashboard?.totalAprobado)}   ${this.moneda}})*100 ` " /> 
                    </th>
                    <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable))}  ${this.moneda} }{${this.formatoNumero(this.dashboard?.totalAprobado)}   ${this.moneda}})*100 ` " /> 
                    </th>
                    <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero( (this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable))}  ${this.moneda} }{${this.formatoNumero(this.totalSaldoRangos)}   ${this.moneda}})*100 ` " /> 
                    </th>


                    <!-- <th>{{ ((((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias)
                      /
                      this.totalSaldoRangos) * 100) + (((this.dashboard?.saldoMoraContable) / this.totalSaldoRangos) *
                        100
                      )).toFixed(2) }} %</th> -->
                  </tr>

                </tbody>
                <tbody v-if="this.estadoMora === 3">
                  <tr>
                    <!-- <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital 1-30 días} }{\\text{Total Saldo Capital}} \\right) *100` " /> 
                    </td> -->
                    <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital > 30 días} }{\\text{Cartera Total}} \\right) *100` " /> 
                    </td>
                    <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital >= 1 día} }{\\text{Cartera Total}} \\right) *100` " /> 
                    </td>
                    <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital >= 1 día} }{\\text{Total Saldo Capital}} \\right) *100` " /> 
                    </td>


                  </tr>

                </tbody>
              </table>
              </div>
            </div>


          </div>

          <!-- ****************************************************************************************** -->
          <div class="row align-items-center">
          <div v-if="readyCambioMora" class="col-md-6 col-12 p-0">
            <AlertaCambioRango
            :creditos1="this.creditosCambioMora.alertaMora1Dia"
            :creditos31="this.creditosCambioMora.alertaMora31Dias"
            :creditos61="this.creditosCambioMora.alertaMora61Dias"
            :creditos90="this.creditosCambioMora.alertaMora90Dias"
            />
          </div>
          <div v-else>
            <div class="col-md-6 col-12 d-flex justify-content-center align-items-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12 ">
          <div class="horizontal-scrollable ">
          <!-- Indicadores de Cartera 1 -->
          <div class="indicadores indicadores-cartera-panel d-flex flex-column">
            <div class="indicadores-header">
              <div>
                <p class="indicadores-eyebrow">Monitoreo</p>
                <h4>Indicadores de Cartera</h4>
              </div>
              <button @click="detallesIndicadores()" class="btn btn-outline-dark mora-toggle-btn indicadores-detail-btn" type="button">
                <i :class="mostrarDetalles ? 'fa-solid fa-eye-slash' : 'fa-solid fa-circle-info'"></i>
                <span>{{ mostrarDetalles ? 'Ocultar detalle' : 'Mostrar detalle' }}</span>
              </button>
            </div>

            <div v-if="!mostrarDetalles" class="colores-cantidades indicadores-legend">
              <div class="bg-success">Óptimo </div>
              <div class="bg-warning">Moderado</div>
              <div class="bg-critico">Crítico</div>
              <div class="bg-danger">Alerta Máxima</div>
            </div>

            <div class="indicadores-list">
            <div class="indicardor-calidad-cartera indicador-row d-flex "
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera" :class="indicadoresColores(this.calidadCartera)">
                <span class="indicador-icon"><i class="fa-solid fa-bolt"></i></span>
                <span class="indicador-main">
                  <span class="indicador-title">Calidad de Cartera</span>
                  <strong>{{ Math.floor(this.calidadCartera) }}%</strong>
                </span>
                <span class="indicador-status">{{ etiquetaIndicador(this.calidadCartera) }}</span>
              </div>

              <div v-if="mostrarDetalles" class="indicador-formulas d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaCalidadCartera" /> &nbsp;
                <MathFormula :formula="formulaCalidadCarteraVariables" />


              </div>
            </div>
            <div class="indicador-interes-vencido indicador-row d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera mt-2" :class="indicadoresColores(this.InteresVencido)">
                <span class="indicador-icon"><i class="fa-solid fa-percent"></i></span>
                <span class="indicador-main">
                  <span class="indicador-title">Tasa de Interes Vencido</span>
                  <strong>{{ Math.floor(this.InteresVencido) }}%</strong>
                </span>
                <span class="indicador-status">{{ etiquetaIndicador(this.InteresVencido) }}</span>
              </div>
              <div v-if="mostrarDetalles" class="indicador-formulas d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaInteresVencido" /> &nbsp;
                <MathFormula :formula="formulaInteresVencidoVariables" />

              </div>

            </div>
            <div class="indicador-tasa-incumplimiento indicador-row d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera mt-2" :class="indicadoresColores(this.Incumplimiento)">
                <span class="indicador-icon"><i class="fa-solid fa-triangle-exclamation"></i></span>
                <span class="indicador-main">
                  <span class="indicador-title">Tasa de Incumplimiento</span>
                  <strong>{{ Math.floor(this.Incumplimiento) }}%</strong>
                </span>
                <span class="indicador-status">{{ etiquetaIndicador(this.Incumplimiento) }}</span>
              </div>
              <div v-if="mostrarDetalles" class="indicador-formulas d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaIncumplimiento" /> &nbsp;
                <MathFormula :formula="formulaIncumplimientoVariables" />

              </div>
            </div>
            </div>


          </div>


          <!-- ****************************************************************************************** -->
          <!-- Indicadores de Cartera 2 -->
          <div v-if="false" class="indicadores indicadores-footer d-flex flex-column pb-5">
            <!-- <div class="colores-cantidades">
              <div class="bg-success">Óptimo </div>
              <div class="bg-warning">Moderado</div>
              <div class="bg-critico">Crítico</div>
              <div class="bg-danger">Alerta Máxima</div>
            </div> -->

            <div class="indicardor-calidad-cartera d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera" :class="indicadoresColoresReverse(this.rendimientoCartera)">
                <h4>Rendimiento de Cartera: {{ this.rendimientoCartera }} %</h4>
              </div>

              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaRendimientoCartera" /> &nbsp;
                <MathFormula :formula="formulaRendimientoCarterasVariables" />


              </div>
            </div>
            <div class="indicador-interes-vencido d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera mt-2" :class="indicadoresColoresReverse(this.rotacionCartera)">
                <h4>Rotación de Cartera: {{ this.rotacionCartera }} %</h4>
              </div>
              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaRotacionCartera" /> &nbsp;
                <MathFormula :formula="formulaRotacionCarterasVariables" />

              </div>

            </div>

            
                </div>
            </div>

            
         </div>
      </div>

      <!-- Consentracion de Riesgo -->

            <ConcentracionRiesgo class="mt-4 mb-4" :departamentos="departamentos" :productos="productos" :asesor="this.asesor"
              :departamentoXProducto="dashboard.departamentoXProducto"
              :totalSaldoProductos="dashboard.productosSaldoCapital" :open="open" />

          <!-- Tabla de Indicadores oculto temporalmente
          <h4 class="display-4 text-center mt-3 mb-2">Indicadores por asesor</h4>
          <TablaIndicadores :asesores="this.asesores" />
          -->
          <div class="mt-5 mb-4 d-flex flex-column"
            v-if="(this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)">

            <!-- <h4 class="display-4">Recup</h4> -->

            <div class="row recovery-charts-row">
              <div class="col-lg-6 col-12">
                <section class="recovery-chart-panel">
                  <div class="recovery-chart-header">
                    <div>
                      <p>Recuperacion anual</p>
                      <h4>Recuperacion {{ anioRecuperacion }}</h4>
                    </div>
                    <select v-model.number="anioRecuperacion" class="form-select recovery-year-select" @change="cambiarPeriodoRecuperacion">
                      <option v-for="anio in aniosRecuperacion" :key="anio" :value="anio">{{ anio }}</option>
                    </select>
                  </div>
                  <ResumenMensualChart :resumenMensual="this.resumenMensual"
                    :asesor="this.asesores.find(item => item.id === this.asesor) || {}"/>
                </section>
              </div>

              <div class="col-lg-6 col-12">
                <section class="recovery-chart-panel">
                  <div class="recovery-chart-header">
                    <div>
                      <p>Recuperacion mensual</p>
                      <h4>Recuperacion por Encargado {{ nombreMes(mesRecuperacion) }} {{ anioRecuperacion }}</h4>
                    </div>
                    <select v-model.number="mesRecuperacion" class="form-select recovery-year-select" @change="obtenerPagosMensual(this.asesor)">
                      <option v-for="mes in mesesRecuperacion" :key="mes.value" :value="mes.value">{{ mes.label }}</option>
                    </select>
                  </div>
                  <ResumenPorEncargadoBarChart :resumenEncargados="this.resumenEncargados" />
                </section>
              </div>
            </div>


            <!-- Comparacion de Totales por Año oculto temporalmente
            <div>
              <ComparacionTotalesTable
                :anio-inicio="2020"
                :anio-fin="2025"
                tipo-cartera=""
                estado="ACTIVO"
                producto=""
                :user-admin="0"
                @error="handleError"
                @loaded="handleLoaded"
              />
            </div>
            -->
          </div>

          
          <!-- *************************************************************** -->
          <!-- Es Localizable y Mapa -->
          <div class="row mt-5 mb-5 localizable-map-row">
            <div class="col-12 col-lg-4">
              <section class="localizable-summary-card">
                <h3>Es Localizable</h3>
                <div class="localizable-summary-item">
                  <strong>Localizables:</strong>
                  <p>{{ this.dashboard.noLocalizables }} Creditos</p>
                </div>
                <div class="localizable-summary-item">
                  <strong>No Localizables:</strong>
                  <p>{{ this.dashboard.noNoLocalizables }} Creditos</p>
                </div>
              </section>
            </div>
            <div class="col-12 col-lg-8">
              <div class="dashboard-map-panel">
                <MapClientes :key="`${sucursal}`" :sucursal="this.sucursal" />
              </div>
            </div>
          </div>

          <!-- Estado Proceso oculto temporalmente -->
          <div v-if="false" class="row mt-5 mb-5">
            <div class="col-12">
              <h3 class="display-4 text-center">Estado Proceso</h3>
              <div class="row estadoProceso text-center">
                <div class="col-12 col-lg-3">
                  <strong>Extrajudicial</strong>
                  <p>{{ this.dashboard.estadoProceso?.noExtrajudicial }} Creditos</p>
                </div>
                <div class="col-12 col-lg-2">
                  <strong>Judicial/Legal</strong>
                  <p>{{ this.dashboard.estadoProceso?.noJudicial }} Creditos</p>
                </div>
                <div class="col-12 col-lg-2">
                  <strong>Castigo</strong>
                  <p>{{ this.dashboard.estadoProceso?.noCastigo }} Creditos</p>
                </div>
                <div class="col-12 col-lg-2">
                  <strong>Irregular</strong>
                  <p>{{ this.dashboard.estadoProceso?.noIrregular }} Creditos</p>
                </div>
                <div class="col-12 col-lg-3">
                  <strong>Normal</strong>
                  <p>{{ this.dashboard.estadoProceso?.noNormal }} Creditos</p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="ready && sinInformacion" class="row">
            <div class="col-12">
              <div class="alert alert-warning text-center" role="alert">
                No se encontro informacion para los filtros seleccionados.
              </div>
            </div>
          </div>

          <!-- ******************************************************************* -->

          <!-- Por Producto -->
          <!-- <FinancialProductsChart v-if="this.ready === true" :chartData="this.chartData" /> -->

          <!-- Estadisticas -->

          <!-- Cantidad de Créditos por Género y Edad oculto temporalmente -->
          <div v-if="false" class="container mt-5">
            <div class="row">
              <h4 class="text-center mb-4">Cantidad de Créditos por Género</h4>
              <div class="col-md-6 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class="text-primary text-md-center text-xl-left">Masculino</h4>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noMasculino
                      }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoMasculino) }} {{ this.moneda }} </p>


                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class=" text-md-center text-xl-left" style="color: #F66799;">Femenino:</h4>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noFemenino }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoFemenino) }} {{ this.moneda }} </p>

                    </div>
                  </div>
                </div>
              </div>
              <h4 class="text-center mb-4">Cantidad de Créditos por Edad</h4>
              <div class="col-md-4 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class="text-primary text-md-center text-xl-left">Jovenes</h4>
                    <h5 class="text-primary text-md-center text-xl-left">0-24 años</h5>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noJovenes }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoJovenes) }} {{ this.moneda }} </p>


                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class=" text-md-center text-xl-left" style="color: #FFA700;">Adulto:</h4>
                    <h5 class=" text-md-center text-xl-left" style="color: #FFA700;">25-64 años</h5>

                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noAdultos }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoAdultos) }} {{ this.moneda }} </p>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class=" text-md-center text-xl-left" style="color: #008C2B;">Adulto Mayor:</h4>
                    <h5 class=" text-md-center text-xl-left" style="color: #008C2B;">Mayores a 65 años</h5>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{
                        this.dashboard.noAdultosMayores }} créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoAdultosMayores) }} {{ this.moneda }} </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div v-else>
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../Footer-App.vue"
import Security from "../security";
import html2pdf from 'html2pdf.js'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

// import FinancialProductsChart from './FinancialProductsChart.vue';

import { store } from "../store";
import MapClientes from "./Map-Clientes.vue";
import MathFormula from "../MathFormula.vue";
import ConcentracionRiesgo from "./ConcentracionRiesgo.vue";
// import TablaIndicadores from "./TablaIndicadores.vue";
import ResumenMensualChart from "./ResumenMensualChart.vue";
import ResumenPorEncargadoBarChart from "./ResumenMensualBarChart.vue";
import AlertaCambioRango from "./AlertaCambioRango.vue";
// import ComparacionTotalesTable from "./ComparacionTotalesTable.vue";

export default {
  name: 'DashboardApp',
  components: {
    Footer,
    // FinancialProductsChart,
    MapClientes,
    MathFormula,
    ConcentracionRiesgo,
    // TablaIndicadores,
    ResumenMensualChart,
    ResumenPorEncargadoBarChart,
    AlertaCambioRango,
    VueDatePicker,
    // ComparacionTotalesTable,

  },
  data() {
    return {
      componentKey: 0,
      reload: false,
      store,
      moneda: 'lps',
      ready: false,
      dashboard: {},
      sinInformacion: false,
      mostrarColumnasDetalleMora: false,
      sucursales: [],
      sucursalesBase: [],
      asesores: [],
      sucursal: '',
      asesor: 'Mostrar Todos',
      estadoSeleccionado: '0',
      productoNombre: [],
      productoResultado: [],
      resumenMensual: {},
      snapshotsDisponibles: [],
      snapshotSeleccionado: null,
      fechaSnapshotSeleccionada: null,
      historicoActivo: false,
      anioRecuperacion: new Date().getFullYear(),
      mesRecuperacion: new Date().getMonth() + 1,
      calidadCartera: 0,
      mostrarDetalles: false,
      open: false,
      saldoInicial: (112320640.5 + 2267699.49),
      noClientesRangos: 0,
      totalSaldoRangos: 0.0,
      totalSaldoAtrasadoRangos: 0.0,
      tiposCartera: [],
      resumenEncargados: [],
      comparacionTotalesError: "",
      comparacionTotalesReady: false,
      // Creditos Cambio Mora
      creditosCambioMora: {
        alertaMora1Dia: [],
        alertaMora31Dias: [],
        alertaMora61Dias: [],
        alertaMora90Dias: [],
      },
      readyCambioMora: false,
      // Detalles Mora Porcentajes
      estadoMora: 1, // Comienza en 1


      // Roles
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Cordinador Sucursal', 'Consultor'],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      Asesor: false,
      coordinadorSucursal: false,
      modoThanos: false,
      Consultor: false,
      readyVerMas: false,
      userRoles: [],
      tipoCartera: 0,

      departamentos: [
        'Francisco Morazan', 'Copan', 'Atlantida', 'Cortes', 'Olancho', 'Lempira', 'Yoro', 'Colón', 'Intibucá',
        'Gracias a Dios', 'La Paz', 'Ocotepeque', 'Santa Bárbara', 'Valle', 'Choluteca', 'Comayagua', 'El Paraíso', 'Islas de la Bahía'
      ],

      productos: ['Agricola', 'Creditrabajo 2', 'Creafuturo', 'CREDI TRABAJO1',],

      valores: {
        "Atlantida": {
          "Creafuturo": "4%"
        },
        "Francisco Morazan": {
          "Creditrabajo 2": "3%"
        }
      },
      chartData: {
        labels: [],
        datasets: [{
          label: 'Cantidad de créditos por producto',
          backgroundColor: '#FFC477',
          // data: [999, 600, 170, 620]
          data: []

        }]
      }
    }
  },
  beforeMount() {
    {

      this.obtenerTipoCartera()

      this.userRoles = Security.getUserRoles();
      this.roles.forEach(element => {

        if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
          this[element] = true;
        } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
          this.coordinadorSucursal = true;
        } else if (this.userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
          this.modoThanos = true;
        }



      });

      this.sucursales = ['ALL', 'SIN SUCURSAL'];
      this.sucursalesBase = [...this.sucursales];
      this.sucursal = 'ALL';
      this.fetchSucursalesDisponibles();
      // Asesor 
      fetch(process.env.VUE_APP_API_URL + "/admin/users/sucursal", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.asesores = response?.data?.users || []
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })


      this.obtenerPagosMensual(0)
      this.fetchSnapshotsDisponibles()

    }

  },

  mounted() {

  },
  watch: {
    sucursal(sucursal) {
      this.ready = false

      if (this.Asesor) {
        this.asesor = this.store.user.id
      }
      this.volverDashboardActual(false)
      this.fetchSnapshotsDisponibles()
      this.obtenerDashboardData(sucursal, this.asesor, this.tipoCartera, this.estadoSeleccionado)


    },
    asesor(asesor) {


      this.obtenerDashboardData("ALL", asesor, this.tipoCartera, this.estadoSeleccionado)
      this.volverDashboardActual(false)
      this.fetchSnapshotsDisponibles()

      if (asesor === 'Mostrar Todos') {
        this.sucursal = 'ALL'
        this.sucursales = [...this.sucursalesBase]
      } else {
        const sucursalesAsesor = this.asesores.find(ase => ase.id == asesor)?.sucursal || []
        this.sucursal = 'ALL'
        this.sucursales = this.opcionesUnicas(["ALL", ...sucursalesAsesor.filter((item) => item !== "ALL"), "SIN SUCURSAL"])
      }

      if (asesor === 'Mostrar Todos') {
        this.obtenerPagosMensual(0)
      } else {
        this.obtenerPagosMensual(asesor)
      }

    },
    tipoCartera(tipoCartera) {
      this.ready = false
      this.volverDashboardActual(false)
      this.fetchSnapshotsDisponibles()
      this.obtenerDashboardData(this.sucursal, this.asesor, tipoCartera, this.estadoSeleccionado)
    },
    estadoSeleccionado(estadoSeleccionado) {
      this.ready = false
      this.volverDashboardActual(false)
      this.fetchSnapshotsDisponibles()
      this.obtenerDashboardData(this.sucursal, this.asesor, this.tipoCartera, estadoSeleccionado)
    },
  },

  methods: {
    etiquetaSucursal(sucursal) {
      if (sucursal === 'ALL' || sucursal === 'MOSTRAR TODAS') return 'Mostrar Todos';
      if (sucursal === 'SIN SUCURSAL') return 'Sin Sucursal';
      return sucursal;
    },
    opcionesUnicas(opciones) {
      return [...new Set((opciones || []).filter(Boolean))];
    },
    getSucursalesUsuario() {
      const sucursalesUsuario = Security.getUserSucursal();
      return Array.isArray(sucursalesUsuario?.[0]) ? sucursalesUsuario[0] : [];
    },
    aplicarSucursalesDisponibles(nombresBase) {
      const sucursalesUsuario = this.getSucursalesUsuario();
      const puedeVerTodas = sucursalesUsuario.includes('ALL') || sucursalesUsuario.length === 0;
      const nombres = nombresBase.length > 0 ? nombresBase : sucursalesUsuario.filter((sucursal) => sucursal !== 'ALL');
      const disponibles = puedeVerTodas ? nombres : nombres.filter((nombre) => sucursalesUsuario.includes(nombre));

      this.sucursalesBase = this.opcionesUnicas(['ALL', ...disponibles, 'SIN SUCURSAL']);
      this.sucursales = [...this.sucursalesBase];
      if (!this.sucursales.includes(this.sucursal)) {
        this.sucursal = 'ALL';
      }
    },
    fetchSucursalesDisponibles() {
      fetch(process.env.VUE_APP_API_URL + "/admin/sucursales/all", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.aplicarSucursalesDisponibles([]);
            return;
          }

          const nombres = (response.data?.sucursales || []).map((sucursal) => sucursal.nombre).filter(Boolean);
          this.aplicarSucursalesDisponibles(nombres);
        })
        .catch(() => {
          this.aplicarSucursalesDisponibles([]);
        });
    },
    handleError(error) {
      const mensaje = typeof error === "string"
        ? error
        : error?.message || "Ocurrio un error al cargar la comparacion de totales.";

      this.comparacionTotalesError = mensaje;
      this.comparacionTotalesReady = false;
      this.$emit("error", mensaje);
    },
    handleLoaded() {
      this.comparacionTotalesError = "";
      this.comparacionTotalesReady = true;
    },
    getDashboardVacio() {
      return {
        departamentoXProducto: {},
        departamentos: [],
        estadoProceso: {},
        interesPagosMesHoy: 0,
        montoPagosHoyMesHoy: 0,
        no150Dias: 0,
        no180Dias: 0,
        no181Dias: 0,
        no30Dias: 0,
        no60Dias: 0,
        no89Dias: 0,
        noActivos: 0,
        noAdultos: 0,
        noAdultosMayores: 0,
        noCancelados: 0,
        noCreditos: 0,
        noFemenino: 0,
        noInteresMas30Dias: 0,
        noJovenes: 0,
        noLegal: 0,
        noLocalizables: 0,
        noMasculino: 0,
        noMoraContable: 0,
        noNoLocalizables: 0,
        noVencidos: 0,
        noVigente: 0,
        productos: {},
        productosSaldoCapital: [],
        saldo150Dias: 0,
        saldo180Dias: 0,
        saldo181Dias: 0,
        saldo30Dias: 0,
        saldo60Dias: 0,
        saldo89Dias: 0,
        saldoActivos: 0,
        saldoAdultos: 0,
        saldoAdultosMayores: 0,
        saldoAtrasado150Dias: 0,
        saldoAtrasado180Dias: 0,
        saldoAtrasado181Dias: 0,
        saldoAtrasado30Dias: 0,
        saldoAtrasado60Dias: 0,
        saldoAtrasado89Dias: 0,
        saldoAtrasadoMoraContable: 0,
        saldoAtrasadoVigente: 0,
        saldoCancelados: 0,
        saldoFemenino: 0,
        saldoInteres150Dias: 0,
        saldoInteres180Dias: 0,
        saldoInteres181Dias: 0,
        saldoInteres30Dias: 0,
        saldoInteres60Dias: 0,
        saldoInteres89Dias: 0,
        saldoInteresMas30Dias: 0,
        saldoInteresMoraContable: 0,
        saldoInteresVigente: 0,
        saldoJovenes: 0,
        saldoLegal: 0,
        saldoMasculino: 0,
        saldoMora150Dias: 0,
        saldoMora180Dias: 0,
        saldoMora181Dias: 0,
        saldoMora30Dias: 0,
        saldoMora60Dias: 0,
        saldoMora89Dias: 0,
        saldoMoraContable: 0,
        saldoMoraMoraContable: 0,
        saldoMoraVigente: 0,
        saldoTotalInteres: 0,
        saldoVencidos: 0,
        saldoVigente: 0,
        totalAprobado: 0,
      }
    },
    limpiarDatosDashboard() {
      this.totalSaldoRangos = 0
      this.totalSaldoAtrasadoRangos = 0
      this.noClientesRangos = 0
      this.calidadCartera = 0
      this.departamentos = []
      this.productos = {}
      this.productoNombre = []
      this.productoResultado = []
      this.chartData.labels = []
      this.chartData.datasets[0].data = []
    },
    normalizarAsesorSnapshot(asesor = this.asesor) {
      const asesorNormalizado = Number.parseInt(asesor, 10)
      return Number.isNaN(asesorNormalizado) ? 0 : asesorNormalizado
    },
    filtroSnapshotActual() {
      return {
        sucursal: this.sucursal || 'ALL',
        asesor: this.normalizarAsesorSnapshot(),
        tipoCartera: Number.parseInt(this.tipoCartera, 10) || 0,
        estado: this.estadoSeleccionado || '0',
      }
    },
    fechaKeySnapshot(fecha) {
      if (!fecha) return ''
      const date = new Date(fecha)
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Tegucigalpa',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(date)
      const values = Object.fromEntries(parts.map((part) => [part.type, part.value]))
      return `${values.year}-${values.month}-${values.day}`
    },
    formatearFechaHora(fecha) {
      if (!fecha) return ''
      return new Intl.DateTimeFormat('es-HN', {
        timeZone: 'America/Tegucigalpa',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(fecha))
    },
    deshabilitarFechaSnapshot(fecha) {
      if (!this.snapshotsDisponibles.length) return true
      const fechas = new Set(this.snapshotsDisponibles.map((snapshot) => this.fechaKeySnapshot(snapshot.fechaCorte)))
      return !fechas.has(this.fechaKeySnapshot(fecha))
    },
    fetchSnapshotsDisponibles() {
      fetch(process.env.VUE_APP_API_URL + "/admin/credito/dashboard-snapshots", Security.requestOptions(this.filtroSnapshotActual()))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.snapshotsDisponibles = []
            return
          }
          this.snapshotsDisponibles = response?.data?.snapshots || []
        })
        .catch(() => {
          this.snapshotsDisponibles = []
        })
    },
    seleccionarFechaSnapshot(fecha) {
      if (!fecha) {
        this.volverDashboardActual()
        return
      }

      const fechaKey = this.fechaKeySnapshot(fecha)
      const snapshot = this.snapshotsDisponibles.find((item) => this.fechaKeySnapshot(item.fechaCorte) === fechaKey)
      if (!snapshot) return
      this.cargarSnapshot(snapshot.id)
    },
    cargarSnapshot(id) {
      this.ready = false
      fetch(process.env.VUE_APP_API_URL + "/admin/credito/dashboard-snapshot", Security.requestOptions({ id }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.ready = true
            this.$emit('error', response.message)
            return
          }

          const dashboardData = response?.data?.dashboardData
          this.snapshotSeleccionado = response?.data?.snapshot || null
          this.historicoActivo = true
          this.aplicarDashboardData(dashboardData)
        })
        .catch(error => {
          this.ready = true
          this.$emit('error', error)
        })
    },
    volverDashboardActual(recargar = true) {
      this.historicoActivo = false
      this.snapshotSeleccionado = null
      this.fechaSnapshotSeleccionada = null
      if (recargar) {
        this.obtenerDashboardData(this.sucursal, this.asesor, this.tipoCartera, this.estadoSeleccionado)
      }
    },
    aplicarDashboardData(dashboardData) {
      this.limpiarDatosDashboard()

      if (!dashboardData || Object.keys(dashboardData).length === 0) {
        this.sinInformacion = true
        this.dashboard = this.getDashboardVacio()
        this.ready = true
        return
      }

      this.sinInformacion = false
      this.dashboard = { ...this.getDashboardVacio(), ...dashboardData }

      this.totalSaldoRangos = (this.dashboard.saldoVigente + this.dashboard.saldo30Dias + this.dashboard.saldo60Dias + this.dashboard.saldo89Dias + this.dashboard.saldoMoraContable + this.dashboard.saldo150Dias + this.dashboard.saldo180Dias + this.dashboard.saldo181Dias)
      this.totalSaldoAtrasadoRangos = (this.dashboard.saldoAtrasadoVigente + this.dashboard.saldoAtrasado30Dias + this.dashboard.saldoAtrasado60Dias + this.dashboard.saldoAtrasado89Dias + this.dashboard.saldoAtrasadoMoraContable)
      this.noClientesRangos = (this.dashboard.noVigente + this.dashboard.no30Dias + this.dashboard.no60Dias + this.dashboard.no89Dias + this.dashboard.noMoraContable + this.dashboard.no150Dias + this.dashboard.no180Dias + this.dashboard.no181Dias)

      this.calidadCartera = this.totalSaldoRangos > 0
        ? (this.dashboard.saldoMoraContable + this.dashboard.saldo89Dias + this.dashboard.saldo60Dias + this.dashboard.saldo150Dias + this.dashboard.saldo180Dias + this.dashboard.saldo181Dias) / this.totalSaldoRangos * 100
        : 0

      this.departamentos = this.dashboard.departamentos
      this.productos = this.dashboard.productos

      for (const key in this.dashboard.productos) {
        if (Object.prototype.hasOwnProperty.call(this.dashboard.productos, key)) {
          this.productoNombre.push(key)
          this.chartData.labels.push(key)
          this.chartData.datasets[0].data.push(this.dashboard.productos[key])
        }
      }
      this.ready = true
    },
    detallesMora() {
      // Cambia el valor en orden: 1 → 2 → 3 → 1 → ...
      if (this.estadoMora === 1) {
        this.estadoMora = 2
      } else if (this.estadoMora === 2) {
        this.estadoMora = 3
      } else {
        this.estadoMora = 1
      }
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero)
    },
    etiquetaRangoMora(codigo) {
      const rangos = {
        AL_DIA: 'Al día',
        MORA_1_30: '1 - 30 días',
        MORA_31_60: '31 - 60 días',
        MORA_61_90: '61 - 90 días',
        MORA_91_180: '91 - 180 días',
        MORA_181_MAS: '181 días en adelante',
      }

      return rangos[codigo] || codigo
    },
    indicadoresColores(cantidad) {
      return (Math.floor(cantidad) > 20 ? 'bg-danger' : (Math.floor(cantidad) >= 10.1 && Math.floor(cantidad) < 20) ? 'bg-critico' : (Math.floor(cantidad) >= 5.1 && Math.floor(cantidad) <= 10) ? 'bg-warning' : Math.floor(cantidad) < 5 ? 'bg-success' : 'bg-success')
    },
    etiquetaIndicador(cantidad) {
      const valor = Math.floor(Number(cantidad) || 0)
      if (valor > 20) return 'Alerta Maxima'
      if (valor >= 10.1 && valor < 20) return 'Critico'
      if (valor >= 5.1 && valor <= 10) return 'Moderado'
      return 'Optimo'
    },
    indicadoresColoresReverse(cantidad) {
      return (Math.floor(cantidad) > 20 ? 'bg-success' : (Math.floor(cantidad) >= 10.1 && Math.floor(cantidad) < 20) ? 'bg-warning' : (Math.floor(cantidad) >= 5.1 && Math.floor(cantidad) <= 10) ? 'bg-critico' : Math.floor(cantidad) < 5 ? 'bg-danger' : 'bg-danger')
    },
    porcentajeSeguro(numerador, denominador, decimales = 2) {
      const base = Number(denominador) || 0
      if (base === 0) return Number(0).toFixed(decimales)
      return (((Number(numerador) || 0) / base) * 100).toFixed(decimales)
    },
    detallesIndicadores() {
      this.mostrarDetalles = !this.mostrarDetalles
      this.componentKey++ // Cambia la clave del componente para forzar su recarga
    },
    
    
    obtenerDashboardData(sucursal, asesor, tipoCartera, estadoSeleccionado) {

      if (asesor === 'Mostrar Todos') {
        asesor = 0
      } else {
        asesor = parseInt(asesor)
      }
      fetch(process.env.VUE_APP_API_URL + "/admin/credito/dashboard-data", Security.requestOptions({ sucursal: sucursal, asesor: asesor, tipoCartera: tipoCartera, estado: estadoSeleccionado }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            const dashboardData = response?.data?.dashboardData
            this.aplicarDashboardData(dashboardData)
            console.log('Dashboard data loaded successfully:', this.dashboard);

          }
        })
        .catch(error => {
          this.sinInformacion = true
          this.dashboard = this.getDashboardVacio()
          this.limpiarDatosDashboard()
          this.ready = true
          this.$emit('error', error)
        })


        this.obtenerCambiosMora(sucursal, asesor, tipoCartera)
    },
    obtenerCambiosMora(sucursal, asesor, tipoCartera) {

      if (asesor === 'Mostrar Todos') {
        asesor = 0
      } else {
        asesor = parseInt(asesor)
      }
      fetch(process.env.VUE_APP_API_URL + "/admin/credito/cambio-mora", Security.requestOptions({ sucursal: sucursal, asesor: asesor, tipoCartera: tipoCartera }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.creditosCambioMora = response?.data?.creditosCambioMora || {
              alertaMora1Dia: [],
              alertaMora31Dias: [],
              alertaMora61Dias: [],
              alertaMora90Dias: [],
            },

            console.log('Creditos Cambio Mora:', this.creditosCambioMora);

            this.readyCambioMora = true;

          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },

    obtenerTipoCartera() {

      fetch(process.env.VUE_APP_API_URL + "/admin/credito/tipo-cartera", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.tiposCartera = response.data.tipoCartera

          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },
    obtenerPagosMensual(asesor) {

      const anioActual = new Date().getFullYear()
      if (!this.anioRecuperacion || this.anioRecuperacion > anioActual) {
        this.anioRecuperacion = anioActual
      }
      this.ajustarMesRecuperacion()
      const asesorNormalizado = Number.parseInt(asesor, 10)
      const asesorId = Number.isNaN(asesorNormalizado) ? 0 : asesorNormalizado

      fetch(process.env.VUE_APP_API_URL + "/admin/pagos/PagosResumenMensual", Security.requestOptions({ asesor: asesorId, anio: this.anioRecuperacion, mes: this.mesRecuperacion }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.resumenMensual = response?.data?.resumen_mensual || {}
            this.resumenEncargados = response?.data?.recuperacion_x_asesor || []
            this.mesRecuperacion = response?.data?.mes || this.mesRecuperacion
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },
    cambiarPeriodoRecuperacion() {
      this.ajustarMesRecuperacion()
      this.obtenerPagosMensual(this.asesor)
    },
    ajustarMesRecuperacion() {
      const anioActual = new Date().getFullYear()
      const mesActual = new Date().getMonth() + 1
      const mesMaximo = this.anioRecuperacion === anioActual ? mesActual : 12
      if (!this.mesRecuperacion || this.mesRecuperacion > mesMaximo) {
        this.mesRecuperacion = mesMaximo
      }
    },
    nombreMes(mes) {
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return meses[(Number.parseInt(mes, 10) || 1) - 1] || ''
    },
    generatePDF() {
      const element = this.$refs.pdfContent;
      this.open = true;

      const today = new Date().toISOString().split('T')[0]; // formato: YYYY-MM-DD
      const opt = {
        margin: [10, 10, 10, 10],
        filename: `dashboard-reporte-${today}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: {
          scale: 3,
          useCORS: true,
          scrollY: 0
        },
        jsPDF: {
          unit: 'mm',
          format: [330, 250],
          orientation: 'landscape'
        },
        pagebreak: {
          mode: ['avoid-all', 'css', 'legacy']
        }
      };
      html2pdf().set(opt).from(element).save();
    },
    abrirDetalle(rango) {
      // let creditos
      store.etiqueta = this.etiquetaRangoMora(rango)

      store.rango = rango
      // store.sucursalSeleccionada = "ALL"
      store.sucursalSeleccionada = this.sucursal
      store.asesorSeleccionado = parseInt(this.asesor)  
      store.tipoCarteraSeleccionado = this.tipoCartera
      store.estadoSeleccionado = this.estadoSeleccionado


      // this.$router.push({ name: 'TablaCreditosMora' })
      const routeData = this.$router.resolve({
      name: 'TablaCreditosMora',
      query: {
        sucursal: this.sucursal ?? '',
        asesor: this.asesor ?? '',
        // tipo de cartera string
        tipoCartera: this.tipoCartera,
        estado: this.estadoSeleccionado ?? '',
        rango: rango ?? '',
        etiqueta: this.etiquetaRangoMora(rango),
      } 
    })

    window.open(routeData.href, '_blank', 'noopener')

  }


  },
  computed: {
    aniosRecuperacion() {
      const actual = new Date().getFullYear()
      const inicio = 2020
      const anios = []
      for (let anio = actual; anio >= inicio; anio--) {
        anios.push(anio)
      }
      return anios
    },
    mesesRecuperacion() {
      const anioActual = new Date().getFullYear()
      const mesActual = new Date().getMonth() + 1
      const mesMaximo = this.anioRecuperacion === anioActual ? mesActual : 12
      const meses = []
      for (let mes = 1; mes <= mesMaximo; mes++) {
        meses.push({ value: mes, label: this.nombreMes(mes) })
      }
      return meses
    },
    fechaActualDashboard() {
      return new Intl.DateTimeFormat('es-HN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }).format(new Date())
    },
    fechaDashboardVisible() {
      if (this.historicoActivo && this.snapshotSeleccionado?.fechaCorte) {
        return this.formatearFechaHora(this.snapshotSeleccionado.fechaCorte)
      }
      return this.fechaActualDashboard
    },
    carteraActivaTotal() {
      return (this.dashboard?.noActivos || 0) + (this.dashboard?.noVencidos || 0) + (this.dashboard?.noLegal || 0)
    },
    saldoCarteraActiva() {
      return (this.dashboard?.saldoActivos || 0) + (this.dashboard?.saldoVencidos || 0) + (this.dashboard?.saldoLegal || 0)
    },
    moraFinancieraDashboard() {
      return this.porcentajeSeguro(
        (this.dashboard?.saldo60Dias || 0) + (this.dashboard?.saldo89Dias || 0) + (this.dashboard?.saldoMoraContable || 0),
        this.dashboard?.totalAprobado
      )
    },
    moraContableDashboard() {
      return this.porcentajeSeguro(
        (this.dashboard?.saldo30Dias || 0) + (this.dashboard?.saldo60Dias || 0) + (this.dashboard?.saldo89Dias || 0) + (this.dashboard?.saldoMoraContable || 0),
        this.dashboard?.totalAprobado
      )
    },
    moraTotalDashboard() {
      return this.porcentajeSeguro(
        (this.dashboard?.saldo30Dias || 0) + (this.dashboard?.saldo60Dias || 0) + (this.dashboard?.saldo89Dias || 0) + (this.dashboard?.saldoMoraContable || 0),
        this.totalSaldoRangos
      )
    },
    // Calida de Cartera
    formulaCalidadCartera() {
      return `=(\\frac{${this.formatoNumero((this.dashboard.saldoMoraContable + this.dashboard.saldo89Dias + this.dashboard.saldo60Dias))}   ${this.moneda}}{ ${this.formatoNumero(this.totalSaldoRangos)} ${this.moneda} } )*100 `;
    },
    formulaCalidadCarteraVariables() {
      return ` = \\left( \\frac{\\text{Saldo Capital } \\geq \\text{ a 31 días}}{\\text{Total Saldo Capital}} \\right) *100`;
    },
    // Tasa de Interes Vencido
    formulaInteresVencido() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.saldoInteresMas30Dias)}  ${this.moneda} }{${this.formatoNumero(this.dashboard.saldoTotalInteres)}   ${this.moneda}})*100 `;
    },
    formulaInteresVencidoVariables() {
      return ` = \\left( \\frac{\\text{Saldo Interes } \\geq \\text{ a 30 días}}{\\text{Total Saldo Interes}} \\right) *100`;
    },
    InteresVencido() {
      return this.porcentajeSeguro(this.dashboard.saldoInteresMas30Dias, this.dashboard.saldoTotalInteres)
    },
    // Tasa de Incumplimiento
    formulaIncumplimiento() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.noInteresMas30Dias)}  creditos }{${this.formatoNumero(this.noClientesRangos)}   creditos})*100 `;
    },
    formulaIncumplimientoVariables() {
      return ` = \\left( \\frac{\\text{No. de Créditos } \\geq \\text{ a 30 días}}{\\text{Total No. de Créditos}} \\right) *100`;
    },
    Incumplimiento() {
      return this.porcentajeSeguro(this.dashboard.noInteresMas30Dias, this.noClientesRangos)
    },
    // Rendimiento de Cartera
    formulaRendimientoCartera() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.interesPagosMesHoy)} }{ \\frac{ ${this.formatoNumero(this.saldoInicial)} + ${this.formatoNumero(this.totalSaldoRangos)}}{2}    })*100 `;
    },
    formulaRendimientoCarterasVariables() {
      return ` = \\left( \\frac{\\text{Intereses del Mes }}{(\\frac{saldo Inicial + Saldo Final}{2})} \\right) *100`;
    },
    rendimientoCartera() {
      return this.porcentajeSeguro(this.dashboard.interesPagosMesHoy, ((this.saldoInicial + this.totalSaldoRangos) / 2))
    },
    // Rotacion de Cartera
    formulaRotacionCartera() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.montoPagosHoyMesHoy)}   }{ \\frac{ ${this.formatoNumero(this.saldoInicial)} + ${this.formatoNumero(this.totalSaldoRangos)}}{2}    })*100 `;
    },
    formulaRotacionCarterasVariables() {
      return ` = \\left( \\frac{\\text{Monto Recuperado del Mes }}{(\\frac{saldo Inicial + Saldo Final}{2})} \\right) *100`;
    },
    rotacionCartera() {
      return this.porcentajeSeguro(this.dashboard.montoPagosHoyMesHoy, ((this.saldoInicial + this.totalSaldoRangos) / 2))
    },

  }

}
</script>

<style scoped>
.dashboard-shell {
  background: #EDF0F4;
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 40px;
  background-color: #FFFFFF;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  margin-bottom: 24px;
  color: #fff;
  padding: 10px 14px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin: 0 !important;
}

.dashboard-download-btn {
  border-radius: 999px;
  padding-inline: 1.2rem;
  background-color: #111827;
  border-color: #111827;
}

.dashboard-filters {
  margin-bottom: 12px;
}

.filter-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px 12px 0;
}

.dashboard-select {
  border-radius: 10px;
  border-color: #dbe2ea;
}

.dashboard-kpi-card {
  border: 1px solid #edf0f4;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
}

@media (max-width: 767px) {
  .cardplay {
    padding: 15px;
  }
}
.card {
  border-radius: 16px;
  border: 1px solid #eef2f6;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

@media (max-width: 767px) {
  .card {
    padding: 18px;
    /* Elimina el padding para dispositivos móviles */
  }
}

.card-body {
  height: 100%;
}

iframe {
  width: 100%;
  /* height: 100%; */
  border: none;
  overflow: hidden;
}

img {
  width: 80%;
  /* height: 100%; */
  border: none;
  overflow: hidden;
  border-radius: 70px;
}

.filaRangos:hover {
  background: #eef2ff;
}

.grey {
  color: grey;
}

tr,
th,
td,
th {
  font-size: 12px;
}

.card-2 {
  border-radius: 16px;
  border: 1px solid #e5eaf0;
  background: #ffffff;
  padding-block: 30px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
}

.card-edades {
  display: flex;
  width: 95%;
  border-radius: 14px;
  /* border: 1px solid #acacac88; */
  /* border-left: 2px solid #bebebe; */
  padding-block: 30px;

  /* width: 100px; */
  transition: width 1s ease 0s;

  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
}

.card-edades:hover {
  width: 100%;
}

.estadoProceso {
  background-color: #f8fafc;
  padding: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 15px;
  border: 1px solid #e5eaf0;
}

@media (max-width: 767px) {
  .estadoProceso {
    margin: 10px;

    /* Elimina el padding para dispositivos móviles */
  }
}


.indicadores {
  padding: 4px;
  margin-top: 20px;
  background-color: #f8fafc;
  border-radius: 10px;
  position: relative;
  border: 1px solid #e2e8f0;
}

.indicadores-footer {
  margin-top: 0px;
  border-radius: 0px 0px 5px 5px;

}

.colores-cantidades {
  position: absolute;
  right: 5px;
  margin-top: 50px;

}

/* En pantallas pequeñas (ej. celulares) */
@media (max-width: 768px) {
  .colores-cantidades {
    position: static; /* O relative, según cómo quieras que se comporte */
    right: auto;
    margin-bottom: 15px;
    margin-top: 5px;
  }

  .content-wrapper{
    padding: 10px !important;
  }
}

.colores-footer {
  position: absolute;
  left: 10px;
  width: 120px;
  bottom: 10px;
}

.colores-cantidades div {
  color: white;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 4px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
}


.indicadores-cartera {
  background-color: #0f172a;
  padding: 10px;
  padding-top: 15px;
  color: white;
  padding-bottom: 15px;
  border-radius: 10px;
  width: 280px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.25);
}

.bg-critico {
  background-color: #ff9100 !important;
  /* color: #000 !important; */
}

.table thead th {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 700;
}

.table td,
.table th {
  vertical-align: middle;
}

/* Rediseño ejecutivo inspirado en la referencia visual */
.dashboard-shell {
  background: #EDF0F4;
  padding: 28px;
  color: #111827;
}

.cardplay {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 32px;
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 22px;
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(7, 14, 18, 0.97), rgba(24, 36, 40, 0.94)),
    linear-gradient(45deg, rgba(23, 163, 128, 0.24), transparent);
  color: #ffffff;
}

.dashboard-hero-main {
  max-width: 680px;
}

.dashboard-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  font-weight: 700;
}

.dashboard-brand-icon,
.metric-icon {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex: 0 0 auto;
}

.dashboard-brand-icon {
  color: #0b1719;
  background: #ffffff;
}

.dashboard-eyebrow {
  margin: 0 0 6px;
  color: #9ee7cc;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
}

.dashboard-title {
  margin: 0 !important;
  color: #ffffff;
  font-size: clamp(2rem, 4vw, 4.1rem);
  line-height: 1;
  font-weight: 800;
  letter-spacing: 0;
}

.dashboard-subtitle {
  margin: 14px 0 0;
  color: #d7dee2;
  font-size: 15px;
  max-width: 620px;
}

.dashboard-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.dashboard-context-chip {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  border-radius: 999px;
  color: #0f172a;
  background: rgba(255, 255, 255, 0.96);
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
}

.dashboard-download-btn {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border-radius: 999px;
  padding-inline: 18px;
  background: #ffffff;
  border: 0;
  color: #0b1719;
  font-weight: 700;
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.18);
}

.dashboard-download-btn:hover {
  background: #e8fff6;
  color: #0b1719;
}

.dashboard-filters {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 12px;
  margin: 16px 0 18px;
  padding: 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.filter-item {
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.filter-item label {
  display: block;
  margin: 0 0 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.dashboard-select {
  min-height: 42px;
  margin: 0 !important;
  border-radius: 999px;
  border-color: transparent;
  background-color: #ffffff;
  box-shadow: inset 0 0 0 1px #e2e8f0;
  font-weight: 700;
  color: #0f172a;
}

.dashboard-history-panel {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(280px, 420px);
  align-items: center;
  gap: 14px;
  margin: 0 0 18px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #dbe5e2;
  background: #eef7f3;
}

.history-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.history-copy label {
  margin: 0 0 3px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.history-copy strong {
  color: #0f172a;
  font-size: 16px;
}

.history-copy span {
  color: #475569;
  font-size: 13px;
}

.history-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
}

.dashboard-history-datepicker {
  min-width: 0;
}

.dashboard-history-btn {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  padding-inline: 16px;
  font-weight: 800;
}

.dashboard-kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.metric-card {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 126px;
  padding: 18px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.07);
}

.metric-card-dark {
  color: #ffffff;
  background: #0b1719;
  border-color: #0b1719;
}

.metric-card p,
.metric-card h3,
.metric-card small {
  margin: 0;
}

.metric-card p {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.metric-card-dark p,
.metric-card-dark small {
  color: #cbd5e1;
}

.metric-card h3 {
  margin-top: 4px;
  font-size: clamp(1.45rem, 2.5vw, 2.4rem);
  font-weight: 800;
  line-height: 1.05;
  color: inherit;
}

.metric-card h3 span {
  font-size: 13px;
  font-weight: 700;
}

.metric-card small {
  display: block;
  margin-top: 6px;
  color: #64748b;
}

.metric-icon {
  color: #0b1719;
  background: #e2f5ed;
}

.metric-icon-warning {
  background: #fff4d6;
  color: #92400e;
}

.metric-icon-success {
  background: #dffbea;
  color: #166534;
}

.metric-icon-info {
  background: #e5f0ff;
  color: #1d4ed8;
}

.metric-icon-muted {
  background: #f1f5f9;
  color: #475569;
}

.dashboard-kpi-card {
  display: none;
}

.card,
.card-2,
.card-edades,
.estadoProceso,
.indicadores {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.card-2 {
  padding: 22px 14px;
  margin: 0 0 18px;
  overflow-x: auto;
}

.card-edades {
  width: 100%;
  min-height: 150px;
  padding: 18px;
  transition: none;
}

.card-edades:hover {
  width: 100%;
}

.estadoProceso {
  padding: 18px 8px;
}

.indicadores {
  padding: 18px;
  margin-top: 0;
}

.indicadores-footer {
  border-top: 0;
  border-radius: 0 0 8px 8px;
}

.card-2 h4,
.container h4,
.container h3,
.mt-5 > h4,
.mt-5 > h3,
.display-4,
.display-5,
.display-6 {
  color: #111827 !important;
  font-weight: 800;
  letter-spacing: 0;
}

.horizontal-scrollable {
  overflow-x: auto;
}

.colores-cantidades {
  right: 18px;
  top: 20px;
  margin-top: 0;
}

.colores-cantidades div {
  border-radius: 999px;
  padding: 5px 10px;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 800;
  box-shadow: none;
}

.indicadores-cartera {
  padding: 14px 16px;
  border-radius: 8px;
  width: min(100%, 340px);
  box-shadow: none;
}

.indicadores-cartera h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
}

.indicadores-cartera-panel {
  position: relative;
  gap: 16px;
  padding: 20px !important;
}

.indicadores-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.indicadores-header h4,
.indicadores-eyebrow {
  margin: 0;
}

.indicadores-header h4 {
  color: #111827;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.15;
}

.indicadores-eyebrow {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.indicadores-detail-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding-inline: 14px;
  white-space: nowrap;
}

.indicadores-legend {
  position: static !important;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
}

.indicadores-legend div {
  margin: 0 !important;
  box-shadow: none !important;
}

.indicadores-list {
  display: grid;
  gap: 10px;
}

.indicadores-list .indicador-row {
  align-items: stretch;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 0 !important;
}

.indicadores-list .indicadores-cartera {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 58px;
  margin-top: 0 !important;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.indicador-icon {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #0f766e;
  background: rgba(255, 255, 255, 0.92);
  font-size: 11px;
}

.indicador-main {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  line-height: 1.1;
}

.indicador-title {
  color: rgba(255, 255, 255, 0.94);
  font-size: 13px;
  font-weight: 800;
}

.indicador-main strong {
  margin-top: 3px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
}

.indicador-status {
  flex: 0 0 auto;
  padding: 7px 13px;
  border-radius: 7px;
  color: #0f5132;
  background: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.indicador-formulas {
  min-width: 0;
  flex: 1 1 100%;
  align-items: center;
  overflow-x: auto;
  margin-left: 0 !important;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
}

.filaRangos:hover {
  background: #ecfdf5;
}

.table {
  margin-bottom: 0;
  color: #111827;
}

.table thead th {
  background: #f8fafc !important;
  color: #0f172a;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
}

.table td,
.table th {
  padding: 0.78rem 0.75rem;
}

.mora-table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.mora-table-toolbar h4 {
  margin: 0 !important;
  flex: 1;
}

.mora-percent-toolbar {
  align-items: flex-start;
}

.mora-percent-toolbar h4 {
  font-size: 18px;
  line-height: 1.2;
}

.mora-percent-context {
  margin: 0 0 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.mora-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.dashboard-mora-row {
  align-items: flex-start;
}

.recovery-charts-row {
  row-gap: 16px;
  margin-top: 28px;
}

.recovery-chart-panel {
  height: 100%;
  min-width: 0;
  padding: 18px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.recovery-chart-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.recovery-chart-header p,
.recovery-chart-header h4 {
  margin: 0;
}

.recovery-chart-header p {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.recovery-chart-header h4 {
  margin-top: 3px;
  color: #111827;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}

.recovery-year-select {
  width: auto;
  min-width: 112px;
  min-height: 40px;
  border-radius: 999px;
  border-color: #e2e8f0;
  color: #0f172a;
  font-weight: 800;
}

.localizable-map-row {
  row-gap: 18px;
  align-items: stretch;
}

.localizable-summary-card,
.dashboard-map-panel {
  height: 100%;
  min-width: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.localizable-summary-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  padding: 22px;
}

.localizable-summary-card h3 {
  margin: 0 0 6px;
  color: #111827;
  font-size: 22px;
  font-weight: 800;
}

.localizable-summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-top: 1px solid #edf0f4;
}

.localizable-summary-item strong,
.localizable-summary-item p {
  margin: 0;
}

.localizable-summary-item strong {
  color: #475569;
  font-size: 14px;
  font-weight: 800;
}

.localizable-summary-item p {
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
  text-align: right;
}

.dashboard-map-panel {
  overflow: hidden;
  padding: 12px;
}

.mora-column-panel {
  min-width: 0;
}

.mora-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 6px;
}

.mora-scroll-wrapper::-webkit-scrollbar {
  height: 9px;
}

.mora-scroll-wrapper::-webkit-scrollbar-track {
  background: #e5e7eb;
  border-radius: 999px;
}

.mora-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 999px;
}

.mora-percent-scroll .table {
  table-layout: auto;
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.mora-percent-scroll th,
.mora-percent-scroll td {
  white-space: nowrap;
  min-width: max-content;
  text-align: center;
  vertical-align: middle;
}

.mora-percent-scroll thead th {
  color: #475569;
  font-size: 12px;
  text-transform: uppercase;
}

.mora-percent-scroll tbody th,
.mora-percent-scroll tbody td {
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
}

.mora-rangos-table {
  table-layout: auto;
  width: max-content;
  min-width: 100%;
}

.mora-rangos-table th {
  line-height: 1.2;
  white-space: nowrap;
  overflow-wrap: normal;
  word-break: normal;
  vertical-align: middle;
}

.mora-rangos-table th,
.mora-rangos-table td {
  width: auto;
  min-width: max-content;
  white-space: nowrap;
}

.mora-rangos-table .mora-total-header {
  width: auto;
  min-width: max-content;
  max-width: none;
  text-align: left;
}

.mora-rangos-table .mora-vencido-header {
  text-align: left;
}

.mora-rangos-table .mora-left-header {
  text-align: left;
}

.mora-rangos-table .mora-clientes-header {
  width: auto;
  min-width: max-content;
}

.mora-rangos-table .mora-percent-header {
  width: auto;
  min-width: max-content;
  text-align: center;
}

.mora-rangos-table .mora-detail-column {
  max-width: 0;
  width: 0;
  min-width: 0;
  opacity: 0;
  padding-left: 0;
  padding-right: 0;
  border-left-width: 0;
  border-right-width: 0;
  overflow: hidden;
  white-space: nowrap;
  transform: translateX(-8px);
  transition:
    max-width 0.34s ease,
    width 0.34s ease,
    opacity 0.24s ease,
    padding 0.34s ease,
    transform 0.34s ease;
}

.mora-rangos-table.mora-detalle-visible .mora-detail-column {
  max-width: none;
  width: auto;
  min-width: max-content;
  opacity: 1;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  overflow: visible;
  white-space: nowrap;
  transform: translateX(0);
}

.table-danger,
.table-dark {
  --bs-table-bg: #0b1719;
  --bs-table-color: #ffffff;
  color: #ffffff;
}

.table-light,
.table-secondary {
  --bs-table-bg: #f1f5f9;
}

.btn {
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0;
}

img {
  max-width: 100%;
  border-radius: 8px;
}

:deep(.accordion) {
  border-radius: 8px !important;
  overflow: hidden;
  border: 1px solid #e5e7eb !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

:deep(.accordion-button) {
  background: #ffffff;
  color: #111827;
  font-weight: 800;
  box-shadow: none;
}

:deep(.accordion-button:not(.collapsed)) {
  background: #ecfdf5;
  color: #0f5132;
}

:deep(.table-responsive) {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  overflow: auto;
}

:deep(.tabla-scrollable) {
  border-radius: 8px;
  border-color: #e5e7eb !important;
}

@media (max-width: 1199px) {
  .dashboard-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dashboard-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dashboard-history-panel {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .dashboard-shell {
    padding: 10px !important;
  }

  .cardplay {
    padding: 15px;
  }

  .dashboard-hero {
    padding: 18px;
    flex-direction: column;
  }

  .dashboard-actions,
  .dashboard-context-chip,
  .dashboard-download-btn {
    width: 100%;
  }

  .dashboard-actions {
    justify-content: stretch;
  }

  .dashboard-context-chip,
  .dashboard-download-btn {
    justify-content: center;
  }

  .dashboard-filters,
  .dashboard-kpi-grid {
    grid-template-columns: 1fr;
  }

  .history-controls {
    grid-template-columns: 1fr;
  }

  .dashboard-history-btn {
    justify-content: center;
    width: 100%;
  }

  .metric-card {
    min-height: 112px;
  }

  .mora-table-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .mora-toggle-btn {
    justify-content: center;
    width: 100%;
  }

  .colores-cantidades {
    position: static;
    margin: 0 0 14px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .indicadores {
    padding: 14px;
  }

  .indicadores-cartera {
    width: 100%;
  }

  .indicardor-calidad-cartera,
  .indicador-interes-vencido,
  .indicador-tasa-incumplimiento {
    flex-direction: column;
    margin-left: 0 !important;
  }

  tr,
  th,
  td {
    font-size: 11px;
  }
}
</style>
